import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { MenuContext } from './context/menuContext'
import style from './MenuFiltros.module.css'
import MenuFiltrosBuscador from './MenuFiltrosBuscador'

const MenuFiltros = ({ idComponente, onBuscar, placeholder, ocultarMenu, titulo }) => {
  const { menus } = useContext(MenuContext)
  const location = useLocation()

  return (
    <div className="row">
      <div className="col">
        <div className="section">
          <div className="barra-herramientas" style={{ backgroundColor: 'white' }}>
            {!ocultarMenu && (
              <div>
                {menus
                  .filter((menu) => menu.idComponente === idComponente)
                  .map((menufiltros) => {
                    const isActive = location.pathname === `/${menufiltros.link}`

                    return (
                      <Link
                        key={menufiltros.idMenu}
                        to={`/${menufiltros.link}`}
                        className={`${style.tab} ${isActive ? style.active : ''}`}
                      >
                        {menufiltros.nombre}
                      </Link>
                    )
                  })}
              </div>
            )}
            {onBuscar && (
              <MenuFiltrosBuscador
                onBuscar={onBuscar}
                placeholder={placeholder}
                titulo={titulo}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

MenuFiltros.propTypes = {
  idComponente: PropTypes.number.isRequired,
  onBuscar: PropTypes.func,
  placeholder: PropTypes.string,
  ocultarMenu: PropTypes.bool,
  titulo: PropTypes.string
}

export default React.memo(MenuFiltros)
